module.exports = __webpack_public_path__ + "img/create-title.0593e2e4.png";